module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="base-form">\n	<h1><strong>Have you played '+
((__t=( game_title ))==null?'':_.escape(__t))+
' before?</strong></h1>\n	<p>This will allow us to match your previous '+
((__t=( game_title ))==null?'':_.escape(__t))+
' account details and team history with your new NRL Account</p>\n	<div class="buttons-wrapper">\n		<button type="button" class="btn secondary-btn js-no">No</button>\n		<button type="submit" class="btn primary-btn js-yes" onClick="return false;">Yes</button>\n	</div>\n</form>';
}
return __p;
};
